import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import IconButton from 'components/clickables/IconButton';
import Text from 'components/Text';

import cxHelpers from 'util/className';

const BOX_STYLE = { minHeight: 60 };

@cxHelpers('MessageDrawerListHeader')
export default class MessageDrawerListHeader extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    titleLink: PropTypes.string,
    handleReturn: PropTypes.func,
    handleClose: PropTypes.func.isRequired,
  };

  onClickLink = () => {
    const { titleLink } = this.props;
    window.Homebase.RailsReactBridge.navigateToReactView(titleLink);
  };

  renderTitle() {
    const { title, titleLink } = this.props;

    if (titleLink) {
      return (
        <Button onClick={this.onClickLink} theme="link">
          {title}
        </Button>
      );
    }

    return title;
  }

  render() {
    const { handleReturn, handleClose } = this.props;

    return (
      <Box bb row spacebetween vcenter style={BOX_STYLE}>
        <Box plxxs row vcenter>
          <IconButton
            onClick={handleReturn}
            type="chevronLeft"
            iconColor="blue"
            size="sm"
            cramped
          />
          <Box plxxs w={270} ellipsis>
            <Text grayXDark fs14 fw600>
              {this.renderTitle()}
            </Text>
          </Box>
        </Box>
        <Box mla>
          <IconButton
            onClick={handleClose}
            type="mdClose"
            iconColor="grayDark"
            size="sm"
          />
        </Box>
      </Box>
    );
  }
}
